
import http from "../http-common";

class CalibrationOrderService {
  getAll() {
    return http.get("/calibrationorders");
  }

  get(calibrationOrderID) {
    return http.get(`/calibrationorders/${calibrationOrderID}`);
  }

  getCalibrationCalibrationOrders(calibrationID) {
    return http.get(`/calibrationorders/?calibrationid=${calibrationID}`);
  }

  create(data) {
    return http.post("/calibrationorders", data);
  }

  update(calibrationOrderID, data) {
    return http.put(`/calibrationorders/${calibrationOrderID}`, data);
  }

  delete(calibrationOrderID) {
    return http.delete(`/calibrationorders/${calibrationOrderID}`);
  }

  deleteAll() {
    return http.delete(`/calibrationorders`);
  }

  emailSchedule(calibrationOrderID) {
    return http.put(`/calibrationorders/emailschedule/${calibrationOrderID}`);
  }

  emailOrder(calibrationOrderID) {
    return http.put(`/calibrationorders/emailorder/${calibrationOrderID}`);
  }

  emailFulfill(calibrationOrderID) {
    return http.put(`/calibrationorders/emailfulfill/${calibrationOrderID}`);
  }
}

export default new CalibrationOrderService();